import { render, staticRenderFns } from "./SupportMessage.vue?vue&type=template&id=68ff27e2&scoped=true&"
import script from "./SupportMessage.vue?vue&type=script&lang=js&"
export * from "./SupportMessage.vue?vue&type=script&lang=js&"
import style0 from "./SupportMessage.vue?vue&type=style&index=0&id=68ff27e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff27e2",
  null
  
)

export default component.exports